import { useKeyboardTooltip } from '../../../hooks/useKeyboardTooltip';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useTileStatus } from './useTileStatus';
import bundle from '../NovaComponents-Tile-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
export const useTileKeyboardTooltip = props => {
  const localize = useTextLocalizer();
  const status = useTileStatus(props);
  const keyboardTooltips = [];
  if (props.disableInteractiveMode) {
    // Only show the keyboard tooltip of its content when interactive mode is disabled
    if (props.title) {
      keyboardTooltips.push(props.title);
    }
    if (status) {
      keyboardTooltips.push(status);
    }
    if (props.selected) {
      keyboardTooltips.push(localize('selected.keyboard.tooltip.label'));
    }
  } else {
    // Show the keyboard tooltip of how to enter interactive mode if enabled
    keyboardTooltips.push(localize('interactiveMode.hint.keyboardTooltip.label'));
  }
  const setKeyboardTooltipRef = useKeyboardTooltip({
    tooltip: keyboardTooltips.join(', ')
  });
  return setKeyboardTooltipRef;
};
//# sourceMappingURL=useTileKeyboardTooltip.js.map